export default "__VITE_ASSET__01b3752c__"